export default __webpack_public_path__ + "static/media/SELLOS_DISCOS_04.e7b48adb.png";